function initWooNoticeToasts() {
	const noticeSelector = ".woocommerce-message:not(.smx-inline-notice), .woocommerce-error:not(.smx-inline-notice), .woocommerce-info:not(.smx-inline-notice)";
	const displayDuration = 10000;
	const exitDuration = 450;
	let container = null;

	function getContainer() {
		if (container) {
			return container;
		}

		container = document.createElement("div");
		container.className = "smx-woocommerce-toasts";
		container.setAttribute("aria-live", "polite");
		container.setAttribute("aria-relevant", "additions");
		document.body.appendChild(container);

		return container;
	}

	function dismiss(notice) {
		if (!notice.isConnected || notice.classList.contains("is-hiding")) {
			return;
		}

		notice.classList.add("is-hiding");
		window.setTimeout(() => notice.remove(), exitDuration);
	}

	function scheduleDismiss(notice, delay = displayDuration) {
		window.clearTimeout(notice.smxToastTimer);
		notice.smxToastRemaining = delay;
		notice.smxToastStartedAt = Date.now();
		notice.smxToastTimer = window.setTimeout(() => dismiss(notice), delay);
	}

	function pauseDismiss(notice) {
		window.clearTimeout(notice.smxToastTimer);
		const elapsed = Date.now() - notice.smxToastStartedAt;
		notice.smxToastRemaining = Math.max(0, notice.smxToastRemaining - elapsed);
	}

	function resumeDismiss(notice) {
		if (notice.classList.contains("is-hiding")) {
			return;
		}

		if (notice.smxToastRemaining <= 0) {
			dismiss(notice);
		} else {
			scheduleDismiss(notice, notice.smxToastRemaining);
		}
	}

	function registerNotice(notice) {
		if (!(notice instanceof HTMLElement) || notice.dataset.smxToastReady === "true") {
			return;
		}

		notice.dataset.smxToastReady = "true";
		notice.classList.add("smx-woocommerce-toast");
		getContainer().appendChild(notice);
		notice.addEventListener("mouseenter", () => pauseDismiss(notice));
		notice.addEventListener("mouseleave", () => resumeDismiss(notice));
		notice.addEventListener("focusin", () => pauseDismiss(notice));
		notice.addEventListener("focusout", () => resumeDismiss(notice));
		scheduleDismiss(notice);
	}

	function scanNotices(root = document) {
		if (root instanceof HTMLElement && root.matches(noticeSelector)) {
			registerNotice(root);
		}

		if (root.querySelectorAll) {
			root.querySelectorAll(noticeSelector).forEach(registerNotice);
		}
	}

	scanNotices();

	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				if (node.nodeType === Node.ELEMENT_NODE) {
					scanNotices(node);
				}
			});
		});
	});

	observer.observe(document.body, { childList: true, subtree: true });
}

function init() {
	initWooNoticeToasts();

	(function ($) {
		var timeout_a;

		function applyFragments(fragments) {
			if (!fragments || typeof fragments !== "object") {
				return;
			}

			Object.keys(fragments).forEach((selector) => {
				$(selector).replaceWith(fragments[selector]);
			});
		}

		function showAddedToCartNotice() {
			const notice = document.createElement("div");
			notice.className = "woocommerce-message";
			notice.setAttribute("role", "status");
			notice.textContent = (window.smxWoo && window.smxWoo.addedToCartNotice) || "Prodotto aggiunto al carrello.";
			document.body.appendChild(notice);
		}

		$(document).on("change", ".woocommerce-ordering select.orderby", function submit_catalog_ordering() {
			if (this.form && this.form.dataset.smxOrderingSubmitting !== "true") {
				this.form.dataset.smxOrderingSubmitting = "true";
				this.form.submit();
			}
		});

		$(document).on(
			"click",
			"a.add_to_cart_button[data-product_id], a.button-add-to-cart[data-product_id]",
			function add_to_cart_archive(event) {
				event.preventDefault();

				const $button = $(this);
				const endpoint = window.smxWoo && window.smxWoo.addToCartUrl;

				if (!endpoint || $button.hasClass("loading")) {
					return;
				}

				const data = {
					product_id: $button.data("product_id"),
					quantity: $button.data("quantity") || 1,
				};

				$(document.body).trigger("adding_to_cart", [$button, data]);
				$button.addClass("loading disabled").attr("aria-disabled", "true");

				$.ajax({
					type: "POST",
					url: endpoint,
					data,
					dataType: "json",
					success(response) {
						if (response && response.error && response.product_url) {
							window.location.href = response.product_url;
							return;
						}

						const fragments = response && response.fragments;
						const cartHash = response && response.cart_hash;

						applyFragments(fragments);
						showAddedToCartNotice();
						$(document.body).trigger("added_to_cart", [fragments, cartHash, $button]);
					},
					complete() {
						$button.removeClass("loading disabled").removeAttr("aria-disabled");
					},
				});
			}
		);

		//disable + and - when the quantity reaches max or min
		function syncQuantityButtons($quantity) {
			$quantity.each(function () {
				var qty = $(this).find(".qty");
				var val = parseFloat(qty.val()) || 0;
				var max = parseFloat(qty.attr("max"));
				var min = parseFloat(qty.attr("min")) || 0;

				$(this).find("button.plus").prop("disabled", max > 0 && val >= max);
				$(this).find("button.minus").prop("disabled", val <= Math.max(min, 1));
			});
		}

		syncQuantityButtons($(".quantity"));
		$(document.body).on("updated_cart_totals updated_wc_div wc_fragments_refreshed", function () {
			syncQuantityButtons($(".quantity"));
		});
		$(document).on("input change", ".quantity .qty", function () {
			syncQuantityButtons($(this).closest(".quantity"));
		});

		//customize product quantity input
		$(document).on(
			"click",
			".woocommerce-cart-form button.plus, .woocommerce-cart-form button.minus, .cart button.plus, .cart button.minus",
			function () {
				var qty = $(this).parents(".quantity").find(".qty");
				var val = parseInt(qty.val());
				var max = parseInt(qty.attr("max")) || 999999;
				var min = parseInt(qty.attr("min"));
				var step = parseInt(qty.attr("step"));

				if ($(this).is(".plus")) {
					if (max && max <= val) {
						qty.val(max);
						qty.attr("value", max);
					} else {
						qty.val(val + step);
						qty.attr("value", val + step);
					}
				} else {
					if (min && min >= val) {
						qty.val(min);
						qty.attr("value", min);
					} else if (val > 1) {
						qty.val(val - step);
						qty.attr("value", val - step);
					}
				}

				syncQuantityButtons($(this).closest(".quantity"));

				if (timeout_a !== undefined) {
					clearTimeout(timeout_a);
				}

				timeout_a = setTimeout(function () {
					$("button[name='update_cart']").prop("disabled", false);
					$("button[name='update_cart']").trigger("click");
					$("button[name='update_cart']").prop("disabled", true);
				}, 500);
			}
		);

		var timeout_b;

		$(document).on(
			"change",
			".woocommerce-cart-form .quantity .qty, .add-to-cart-container .cart .quantity .qty",
			function () {
				if (timeout_b !== undefined) {
					clearTimeout(timeout_b);
				}

				timeout_b = setTimeout(function () {
					$("button[name='update_cart']").prop("disabled", false);
					$("button[name='update_cart']").trigger("click");
					$("button[name='update_cart']").prop("disabled", true);
				}, 500);
			}
		);

		//AJAX add-to-cart single
		$(document).on(
			"click",
			".cart  button[type='submit'].single_add_to_cart_button ",
			function add_to_cart_single(e) {
				e.preventDefault();

				let button = e.target;
				let form = button.closest("form");
				if (button && form) {
					let productId = button.value;

					if (form.querySelector("[name='product_id']")) {
						productId = form.querySelector("[name='product_id']").value;
					}

					if (form.querySelector("[name='variation_id']")) {
						productId = form.querySelector("[name='variation_id']").value;
					}

					let qnt = form.querySelector("[name='quantity']").value || 1;
					const endpoint = window.smxWoo && window.smxWoo.addToCartUrl;

					if (!endpoint) {
						return;
					}

					var data = {
						action: "add-to-cart",
						product_id: productId,
						quantity: qnt,
					};

					let $button = $(button);

					$(document.body).trigger("adding_to_cart", [$button, data]);
					$button.addClass("disabled");
					$button.addClass("loading");
					$button.attr("disabled", true);

					$.ajax({
						type: "POST",
						dataType: "json",
						url: endpoint,
						data,
						success(response) {
							if (response && response.error && response.product_url) {
								window.location.href = response.product_url;
								return;
							}

							const fragments = response && response.fragments;
							const cartHash = response && response.cart_hash;

							applyFragments(fragments);
							showAddedToCartNotice();
							$(document.body).trigger("added_to_cart", [fragments, cartHash, $button]);
						},
						complete() {
							$button.removeClass("loading disabled").attr("disabled", false);
						},
					});
				}
			}
		);
	})(jQuery);
}

export default { init };
